// extracted by mini-css-extract-plugin
export default {"customButton":"Button_customButton__+7xbO","largeButton":"Button_largeButton__DD-SS"};